module.exports = __webpack_public_path__ + "img/h2.42cef6bf.jpg";